import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { MeasurementFilter } from 'schemas/MeasurementFilterSchema'
import MeasurementType from 'enums/MeasurementType'
import { MetricCategoryItemStrings } from 'enums/MetricCategoryItem'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'
import { resolveValueFromMetric } from '../utils/starRatingsUtil'

const canBeDrilledDown = (widgetSetting: DashboardWidgetType) =>
  widgetSetting.starRatings === undefined || widgetSetting.starRatings === null

const isOverMaxInput = () => false

const composeDrillDownWidgetSetting = (
  widgetSetting: DashboardWidgetType,
  insights: InsightData[]
) => ({
  ...widgetSetting,
  starRatings: [
    ...(widgetSetting.starRatings || []),
    {
      type: MeasurementType.STAR,
      overallChecked: true,
      values: Array.from(insights).map((insight) =>
        resolveValueFromMetric(insight.name! as MetricCategoryItemStrings)
      )
    } as MeasurementFilter
  ]
})

const generateStarRatingsStrategy = (): WidgetSettingComposingStrategy => ({
  canBeDrilledDown,
  isOverMaxInput,
  composeDrillDownWidgetSetting
})

export default generateStarRatingsStrategy
